module.exports = __webpack_public_path__ + "static/call_sheet_page@2x-dc066d6069788c658861919186984b11.png";